module.exports = __webpack_public_path__ + "img/zzh1.80eb97ba.jpg";